import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentSousmenu from "../../components/layout/ComponentSousmenu";
import BlocIdeesDuMoment from "../../components/public/colidee/BlocIdeesDuMoment";
import BlocEmissionsThumbnail from "../../components/public/media/BlocEmissionsThumbnail";
// import BlocGalerie from "../../components/public/media/BlocGalerie";
import ComponentPublications from "../../components/public/media/ComponentPublications";
import ComponentActualites from "../../components/public/colidee/ComponentActualites";
import ContainerInviewsCalendar from "./ContainerInviewsCalendar";
import { Container } from "react-bootstrap";
import BlocFiltreInViews from "../../components/public/view/BlocFiltreInViews";
import BlocToggle from "../../components/layout/ComponentToggle";
import { selectInViewsFilters } from "../../redux/ReduxFilter";

import { chgInviewsToggle, selectInViewsToggle } from "../../redux/ReduxToggle";

const PageInviews = () => {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const _selectInViewFilters = useSelector(selectInViewsFilters);
  const dispatch = useDispatch();

  const [anteriorite, setAnteriorite] = useState(31);
  const [viewToggle, setViewToggle] = useState(useSelector(selectInViewsToggle));

  const switchView = () => {
    dispatch(chgInviewsToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  return (
    <>
      <ComponentMenu menuActif="inviews" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="inViews" isCalendarView={viewToggle} />
        <BlocToggle
          viewToggle={viewToggle}
          switchView={switchView}
          setAnteriorite={setAnteriorite}
          anteriorite={anteriorite}
          max={5}
          min={0}
          disabled={true}
          sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "inViews")}
        />
      </div>

      <BlocFiltreInViews ReduxInstance={ReduxInstance} />

      {!viewToggle && (
        <>
          {(_selectInViewFilters.idee || _selectInViewFilters.all) && <BlocIdeesDuMoment />}
          {(_selectInViewFilters.actualite || _selectInViewFilters.all) && <ComponentActualites />}
          {(_selectInViewFilters.emission || _selectInViewFilters.all) && (
            <BlocEmissionsThumbnail type="emission" />
          )}
          {(_selectInViewFilters.podcast || _selectInViewFilters.all) && (
            <BlocEmissionsThumbnail type="podcast" />
          )}
          {(_selectInViewFilters.publication || _selectInViewFilters.all) && (
            <ComponentPublications />
          )}
        </>
      )}

      {viewToggle && (
        <Container fluid>
          <ContainerInviewsCalendar anteriorite={anteriorite} />
        </Container>
      )}

      {/* <BlocGalerie /> */}
    </>
  );
};

export default PageInviews;
